// selectors/ContactTypes.ts
import _ from "underscore";
import { RootStateOrAny } from "react-redux";
import IContactType from "../../model/interface/company/IContactType";

export const findAll = (store: RootStateOrAny): IContactType[] =>
    Object.values(store.setup.contactTypes ?? []);

export const findBy = (store: RootStateOrAny, property: string, value: any): IContactType[] =>
    _.where(findAll(store), { [property]: value });

export const findOneBy = (store: RootStateOrAny, property: string, value: any): IContactType =>
    _.findWhere(findAll(store), { [property]: value })!;

export const findOneOrNullBy = (store: RootStateOrAny, property: string, value: any): IContactType | undefined =>
    _.findWhere(findAll(store), { [property]: value });

export default { findAll, findBy, findOneBy, findOneOrNullBy };
